import React from "react";
import { Edit } from "react-admin";
import { useTranslate } from "react-admin";
import RulesForm from "./RulesForm";
import { transformData } from "./Services/rulesServices";

const RulesEdit: React.FC = () => {
  const translate = useTranslate();

  return (
    <Edit
      title={translate("rules.create.title")}
      redirect="list"
      transform={transformData}
    >
      <RulesForm />
    </Edit>
  );
};

export default RulesEdit;
